import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { MessageService } from "../../shared/services/message.service";
import { TranslationKeyConstants } from "../../shared/constants/translation-key-constants";

@Injectable()
export class UnauthorizedErrorInterceptorService implements HttpInterceptor {
  private readonly messageService = inject(MessageService);


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(tap(() => {
      },
      async (err: any) => {
        console.log(err);
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 403 ) {
            return;
          }

          this.messageService.showErrorMessage(TranslationKeyConstants.shared.unauthorized);
        }
      }));
  }
}
